import React, { useEffect, useState } from "react";
import api from "../../../../configs/api";
import Loader from "../../../../common/Loader";
import Swal from "sweetalert2";
import EditModal from "./EditModal";

function HomeHeroComponent() {
  const [loading, setLoading] = useState(false);

  const [homeData, setHomeData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [status, setStatus] = useState({
    show: false,
    icon: "success",
    title: "",
    description: "",
    showConfirmButton: true,
    timer: 10000,
  });

  function handleModal(setState, value) {
    setState(value);
  }

  async function getServices() {
    setLoading(true);

    try {
      const res = await api.get("CMS/home-data");

      setHomeData(res?.data?.homeData || {});
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getServices();
  }, []);

  useEffect(() => {
    if (status?.show) {
      Swal.fire({
        position: "center",
        icon: status.icon,
        title: status.title,
        showConfirmButton: status.showConfirmButton,
        timer: status.timer,
      });
      getServices();
    }
    setStatus(false);
  }, [status]);

  if (loading) {
    return <Loader />;
  }
  return (
    <main className='grid gap-4 bg-primary4 m-10 p-10'>
      <div className='flex justify-between'>
        <div>
          <p className='text-2xl font-bold mb-2'>Home Main Image:</p>
          <img
            className='w-[20rem] rounded-lg'
            src={homeData?.mainImage}
            alt='main'
          />
        </div>
        <div>
          <div className='flex justify-end'>
            <button
              onClick={() => handleModal(setIsEdit, true)}
              type='button'
              data-modal-toggle='add-user-modal'
              className='inline-flex items-center justify-center  px-3 py-2 text-sm font-medium text-center rounded-lg text-primary hover:bg-[#3c2154] hover:text-white    sm:w-auto border-2 border-primary'
            >
              <svg
                className='w-6 h-6 mr-2 -ml-1'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  d='M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z'
                  clipRule='evenodd'
                />
              </svg>
              Update Home Data
            </button>
          </div>
        </div>
      </div>
      <div className=''>
        <p className='text-2xl font-bold mb-2'>Home Main Title:</p>
        <div className='border-2 border-gray-700 rounded-lg mb-2'>
          <p className='text-lg font-bold p-6'>{homeData?.mainTitle}</p>
        </div>
      </div>
      <div className=''>
        <p className='text-2xl font-bold mb-2'>Home Sub Title:</p>
        <div className='border-2 border-gray-700 rounded-lg mb-2'>
          <p className='text-lg font-bold p-6'>{homeData?.mainSubTitle}</p>
        </div>
      </div>

      <EditModal
        handleModal={handleModal}
        setIsEdit={setIsEdit}
        isEdit={isEdit}
        setStatus={setStatus}
        url={`CMS/home-data`}
        InfoForUpdate={homeData}
      />
    </main>
  );
}

export default HomeHeroComponent;
